import React, { Fragment } from 'react';
import makeAnimated from 'react-select/animated';
import CreatableSelect from 'react-select/creatable';

const animatedComponents = makeAnimated();

const FormSingleCreatableSelect = (props) => {
    const { label, options, handleMultiSelectChange, prefixes, error, name } = props;

    const customStyles = {
        control: (provided) => ({
            ...provided,
            border: error ? '1px solid red' : provided.border,
        }),
    };

    return (
        <Fragment>
            <label>{label}</label>
            <CreatableSelect
                components={animatedComponents}
                options={options}
                onChange={(value) => handleMultiSelectChange(value)}
                styles={customStyles}
                defaultValue={prefixes}
                name={name}
            />
            {error && <small className="text-danger">{error}</small>}
        </Fragment>
    );
};

export default FormSingleCreatableSelect;
